import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, spacing, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../Select/Select.es.js';
import { SelectNative } from '../Select/SelectNative.es.js';

const CalendarWrapper = styled(Box)`
    background-color: ${themeMode({
  light: palette("neutral.0"),
  dark: palette("neutral.800")
})};
    color: ${themeMode({
  light: palette("neutral.800"),
  dark: palette("neutral.50")
})};
    ${({ isInitialized }) => !isInitialized && "visibility: hidden"}
    user-select: none;
    width: 344px;
`;
const CalendarDatesContainer = styled(Box)`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    button:first-child {
        grid-column: ${({ skipIndex }) => skipIndex};
    }
`;
const CalendarDateButton = styled("button")`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid transparent;
    display: flex;
    justify-content: center;
    place-items: center;
    outline: none;
    cursor: pointer;
    margin: ${spacing("xxs")} ${spacing("xxs")} 0 0;
    &:not(:disabled):hover {
        color: ${palette("neutral.0")};
        background-color: ${palette("primary.500")};
        border-color: ${palette("primary.500")};
    }
    border-color: ${({ isToday }) => isToday && themeMode({
  light: palette("neutral.300"),
  dark: palette("neutral.500")
})};
    &[disabled],
    &:disabled {
        color: ${themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
})};
        cursor: default;
    }
    ${({ active }) => active && css`
            color: ${palette("neutral.0")};
            background-color: ${palette("primary.500")};
            border-color: ${palette("primary.500")};
        `}
`;
const CalendarHeader = styled(Box)`
    border-bottom: ${themeMode({
  light: `1px solid`,
  dark: `1px solid`
})};
    border-bottom-color: ${themeMode({
  light: palette("neutral.200"),
  dark: palette("neutral.700")
})};
    padding: ${spacing("lg")};
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: -1px;
`;
const CalendarWeeksContainer = styled(Box)`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    color: ${themeMode({
  light: palette("neutral.500"),
  dark: palette("neutral.400")
})};
`;
const CalendarHeaderSelect = styled(SelectNative)`
    height: auto;
    min-height: auto;

    & > select {
        min-width: auto;
        padding: 0 ${spacing("xl")} 0 ${spacing("xxs")} !important;
    }
`;
const CalendarHeaderSelectCaret = styled("span")`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    padding: 0 ${spacing("xxs")};
    display: flex;
    place-items: center;
    pointer-events: none;
`;

export { CalendarDateButton, CalendarDatesContainer, CalendarHeader, CalendarHeaderSelect, CalendarHeaderSelectCaret, CalendarWeeksContainer, CalendarWrapper };
//# sourceMappingURL=styled.es.js.map
